import {
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  useToast,
  IconButton,
  useDisclosure,
} from "@chakra-ui/react";
import { Icon } from "@iconify/react";
import React, { useEffect, useMemo } from "react";
import { SharePopup } from "../pages/project-showcase/admin/Presentation/Presentation";
import axios from "axios";
import { getAxiosConfig } from "../utils/helpers";

const ShareButton = ({
  className,
  url = window.location.href,
  title = "Check this out!",
}) => {
  const toast = useToast();

  const { isOpen, onOpen, onClose } = useDisclosure();
  const [token, setToken] = React.useState(null);
  const { id, company } = useMemo(() => {
    let arr = url.split("/");
    return {
      id: arr[arr.length - 2],
      company: arr[arr.length - 1].split("?")[0],
    };
  }, [url]);
  async function fetchToken() {
    try {
      const {
        data: { data },
      } = await axios.get(
        `${process.env.REACT_APP_BACK_URL}/api/presentation/guest-user/${id}`,
        getAxiosConfig(),
      );
      setToken(data);
      onOpen();
      // setPublicLink(publicLink+ "?token="+data);
    } catch (error) {
      console.log("err", error);
      // toast.error('Error in generating public link');
      toast({
        title: "Error generating public link",
        description: "Could not generate the public token.",
        status: "error",
        duration: 2000,
        isClosable: true,
      });
      onClose();
    }
  }

  // console.log("SHARE BUTTON", url, id, company);
  if (!url) return null;
  return (
    <>
      <Button
        onClick={() => fetchToken()}
        size={"sm"}
        colorScheme="green"
        className={className}
      >
        <div className="flex items-center gap-2">
          <Icon icon="mdi:share-variant" width="16" height="16" />
          Share
        </div>
      </Button>
      <SharePopup
        isOpen={isOpen}
        handleClose={() => {
          onClose();
          setToken(null);
        }}
        publicLink={url.split("?")[0] + `?token=${token}`}
      />
    </>
  );
};

export default ShareButton;
